<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <p-divider align="left">
    <div class="inline-flex align-items-center font-bold">
      Inputs
    </div>
  </p-divider>

  <p class="my-2">
    Please select an image file or an <b>expanded</b> folder containing one or more image files in
    the file browser.
  </p>
<!--  <p class="my-2">File selected is : {{this.inputImage?.name}}</p>-->
  <br>
  <div class="field grid">
    <div class="card flex justify-content-center ml-2 mr-2">
      <p-inputSwitch inputId="normOnly" formControlName="normOnly"/>
      <label class="ml-2">
        Apply normalization only
        <i class="pi pi-info-circle px-1"
           pTooltip="If this toggle is on, only color normalization can be run."
           tooltipPosition="left"
        ></i>
      </label>
    </div>
  </div>
  <div class="field grid">
    <label class="col-12 mb-2 md:col-5 md:mb-0 text-black-alpha-90" for="normMethod">
      Normalization method
      <i class="pi pi-info-circle px-1"
         pTooltip="Method used to normalize the input image."
         tooltipPosition="left"
      ></i>
    </label>
    <div class="col-12 md:col-7">
      <p-dropdown
        [options]="normMethods"
        formControlName="normMethod"
        (onChange)="onNormMethodChange($event)"
        id="normMethod"
        placeholder="Select Level">
      </p-dropdown>
    </div>
  </div>
  <div class="field grid">
    <label class="col-12 mb-2 md:col-5 md:mb-0 text-black-alpha-90" for="normTargetPath">
      Normalization target image
      <i class="pi pi-info-circle px-1"
         pTooltip="Image to use as a target for the normalization process."
         tooltipPosition="left"
      ></i>
    </label>
    <div class="col-12 md:col-7">
      <p-dropdown appendTo="body"
        [options]="normTargets"
        formControlName="normTargetPath"
        id="normTargetPath"
        placeholder="Select Target Image"
      >
      </p-dropdown>

    </div>
  </div>
  <div *ngIf="!form.get('normOnly')?.value" class="field grid">
    <div class="field-checkbox mb-2">
      <p-checkbox
        formControlName="saveNormalization"
        [binary]="true"
        class="my-1"
        id="saveNormalization"
      ></p-checkbox>
      <label for="saveNormalization">
        Save normalization
        <i class="pi pi-info-circle px-2"
           pTooltip="If selected, the process will save the normalized image with
           the selected normalization method."
           tooltipPosition="left"
        ></i>
      </label>
    </div>
  </div>
  <div *ngIf="!form.get('normOnly')?.value" class="field grid">
    <label class="col-12 mb-2 md:col-5 md:mb-0 text-black-alpha-90" for="ganModelPath">
      GAN Model
      <i class="pi pi-info-circle px-1"
         pTooltip="Choose GAN model to run the stain adapter process"
         tooltipPosition="left"
      ></i>
    </label>
    <div class="col-12 md:col-7">
      <p-dropdown
        [options]="ganModels"
        formControlName="ganModelPath"
        id="ganModelPath"
        placeholder="Select GAN Model"
        (onChange)="onModelChange($event)"
      >
      </p-dropdown>
    </div>
  </div>
  <div *ngIf="!form.get('normOnly')?.value" class="field grid">
    <label class="col-12 mb-2 md:col-5 md:mb-0 text-black-alpha-90" for="mode">
      Mode
      <i class="pi pi-info-circle px-1"
         pTooltip="lab: use the standard pix2pix model that trained on L channel to
         predict AB channels.
                   gr2rgb: use the standard pix2pix model that trained on greyscale
                   images to predict RGB images."
         tooltipPosition="left"
      ></i>
    </label>
    <div class="col-12 md:col-7">
      <input id="mode" type="text" formControlName="mode" pInputText readonly class="w-full" />
    </div>
  </div>

  <div *ngIf="!form.get('normOnly')?.value" class="field grid">
    <label class="col-12 mb-2 md:col-5 md:mb-0 text-black-alpha-90" for="channelMode">
      Channel Mode
      <i class="pi pi-info-circle px-1"
         pTooltip="Channel mode of the images that the model was train with"
         tooltipPosition="left"
      ></i>
    </label>
    <div class="col-12 md:col-7">
      <input id="channelMode" type="text" formControlName="channelMode" pInputText readonly class="w-full"/>
    </div>
  </div>
  <div *ngIf="!form.get('normOnly')?.value" class="field grid">
    <label class="col-12 mb-2 md:col-5 md:mb-0 text-black-alpha-90" for="patchSize">
      Image Size
      <i class="pi pi-info-circle px-1"
         pTooltip="Image size the model was trained on."
         tooltipPosition="left"
      ></i>
    </label>
    <div class="col-12 md:col-7">
      <input id="patchSize" type="text" formControlName="patchSize" pInputText readonly class="w-full" />
    </div>
  </div>


  <!-- this section becomes visible when file gets selected -->
  <ng-container>
    <p-divider align="left">
      <div class="inline-flex align-items-center font-bold">
        File Destination
      </div>
    </p-divider>

    <!-- output folder -->
    <div class="field grid h-3rem align-items-center">
      <label for="outputFolder" class="col-12 md:col-5 mb-0 text-black-alpha-90">
        Output folder:
      </label>
      <div class="col-12 md:col-7">
        <ng-container *ngIf="form.get('editOutputFolder')?.value; else viewOutputFolder">
          <div class="output-folder-edit">
            <input id="outputFolder" type="text" class="p-inputtext-sm w-full"
                   formControlName="outputFolder" pInputText/>
            <i class="pi pi-times icon-hover" (click)="form.get('editOutputFolder')?.setValue(false)"></i>
          </div>
        </ng-container>
        <ng-template #viewOutputFolder>
          {{form.get('outputFolder')?.value}}
          <i class="pi pi-pencil icon-hover" (click)="form.get('editOutputFolder')?.setValue(true)"></i>
        </ng-template>
      </div>
    </div>
    <div class="pt-3 pb-3">
      <span *ngIf="validationMessage" style="color: red" class="mb-2">{{ validationMessage }}</span>
    </div>
    <div class="pt-3 pb-3 process-buttons">
      <p-button
        type="submit" icon="pi pi-play"
        label="Run"
        styleClass="p-button-primary">
      </p-button>
    </div>

  </ng-container>
</form>
